module.exports = __webpack_public_path__ + "static/media/confetti.75046f78.gif";